/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    code: "code",
    p: "p",
    ul: "ul",
    li: "li",
    h3: "h3",
    a: "a",
    pre: "pre",
    h4: "h4",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h2, {
      children: ["I am a library author. Should I bundle ", _jsx(_components.code, {
        children: "styled-components"
      }), " with my library?"]
    }), "\n", _jsxs(_components.p, {
      children: ["If you are a library author, we recommend that you should not bundle and ship ", _jsx(_components.code, {
        children: "styled-components"
      }), " module with your library. There are two steps that you need to do to achieve this:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Marking ", _jsx(_components.code, {
          children: "styled-components"
        }), " as external in your package dependencies"]
      }), "\n", _jsxs(_components.li, {
        children: ["Removing ", _jsx(_components.code, {
          children: "styled-components"
        }), " from your library bundle"]
      }), "\n"]
    }), "\n", _jsxs(_components.h3, {
      children: ["Marking ", _jsx(_components.code, {
        children: "styled-components"
      }), " as external in your package dependencies"]
    }), "\n", _jsxs(_components.p, {
      children: ["To do this, you will need to move it from ", _jsx(_components.code, {
        children: "dependencies"
      }), " to ", _jsx(_components.a, {
        href: "https://docs.npmjs.com/files/package.json#devdependencies",
        children: _jsx(_components.code, {
          children: "devDependencies"
        })
      }), "\nand include it in the ", _jsx(_components.a, {
        href: "https://docs.npmjs.com/files/package.json#peerdependencies",
        children: _jsx(_components.code, {
          children: "peerDependencies"
        })
      }), " list in your ", _jsx(_components.code, {
        children: "package.json"
      }), " file:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "  {\n-   \"dependencies\" : {\n+   \"devDependencies\" : {\n      \"styled-components\": \"^3.4.9\"\n    },\n+   \"peerDependencies\" : {\n+     \"styled-components\": \">= 3\"\n+   }\n  }\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Moving ", _jsx(_components.code, {
        children: "styled-components"
      }), " to ", _jsx(_components.code, {
        children: "devDependencies"
      }), " will guarantee that it wouldn't be installed along with your library (", _jsx(_components.code, {
        children: "npm install"
      }), " or ", _jsx(_components.code, {
        children: "yarn add"
      }), " will ignore ", _jsx(_components.code, {
        children: "devDependencies"
      }), " when a library is installed)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Adding ", _jsx(_components.code, {
        children: "styled-components"
      }), " to ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " will signal your library consumers that ", _jsx(_components.code, {
        children: "styled-components"
      }), " is not included with the library and they need to install it themselves."]
    }), "\n", _jsxs(_components.p, {
      children: ["Also, note that in the ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " section the version string has been made a more permissive ", _jsx(_components.code, {
        children: ">= 3"
      }), ". This allows future versions of styled-components to work automatically and you can simply narrow the range with a patch update to your library if a breaking change is eventually added."]
    }), "\n", _jsxs(_components.h3, {
      children: ["Removing ", _jsx(_components.code, {
        children: "styled-components"
      }), " from your library bundle"]
    }), "\n", _jsxs(_components.p, {
      children: ["If you are bundling your library before shipping it, make sure that you are not bundling ", _jsx(_components.code, {
        children: "styled-components"
      }), " along with it. Here are some examples of how to do this with some popular module bundling tools:"]
    }), "\n", _jsx(_components.h4, {
      children: "With Microbundle"
    }), "\n", _jsxs(_components.p, {
      children: ["If you are using ", _jsx(_components.a, {
        href: "https://github.com/developit/microbundle",
        children: "Microbundle"
      }), ", it will handle this step automatically. Microbundle treats every dependency in the ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " list as external and excludes it from the build for you."]
    }), "\n", _jsx(_components.h4, {
      children: "With Rollup.js"
    }), "\n", _jsxs(_components.p, {
      children: ["If you are using ", _jsx(_components.a, {
        href: "https://rollupjs.org",
        children: "Rollup.js"
      }), ", you should provide an ", _jsx(_components.a, {
        href: "https://rollupjs.org/guide/en#big-list-of-options",
        children: _jsx(_components.code, {
          children: "external"
        })
      }), " option in your config:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "  export default {\n    entry: \"my-awesome-library.js\",\n+   external: [\n+     \"styled-components\"\n+   ]\n  }\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Another approach is to use the ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/rollup-plugin-peer-deps-external",
        children: "rollup-plugin-peer-deps-external"
      }), " plugin which will automatically add the ", _jsx(_components.code, {
        children: "peerDependencies"
      }), " in the ", _jsx(_components.code, {
        children: "external"
      }), " option array for you."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "+ import peerDepsExternal from 'rollup-plugin-peer-deps-external';\n\n  export default {\n    entry: \"my-awesome-library.js\",\n+   plugins: [\n+    // Preferably set as first plugin.\n+    peerDepsExternal(),\n+   ]\n  }\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "With Webpack"
    }), "\n", _jsxs(_components.p, {
      children: ["If you are using ", _jsx(_components.a, {
        href: "https://webpack.js.org",
        children: "Webpack"
      }), ", you should provide an ", _jsx(_components.a, {
        href: "https://webpack.js.org/configuration/externals/",
        children: _jsx(_components.code, {
          children: "externals"
        })
      }), " option in your config:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-diff",
        children: "  modules.export = {\n    entry: \"my-awesome-library.js\",\n+   externals: {\n+     \"styled-components\": {\n+       commonjs: \"styled-components\",\n+       commonjs2: \"styled-components\",\n+       amd: \"styled-components\",\n+     },\n+   },\n  }\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["You can find more useful information on how to bundle a library with Webpack at ", _jsx(_components.a, {
          href: "https://webpack.js.org/guides/author-libraries/",
          children: "\"Authoring Libraries\""
        }), " section of Webpack documentation."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
